import { ReactNode } from 'react';

interface ClubGridProps {
  topRowLeft?: ReactNode; // Made optional since we moved NewsPanel to left sidebar
  topRowRight: ReactNode;
  teamPanel: ReactNode; // Renamed from middleRow to be more specific
  bottomRowLeft: ReactNode;
  bottomRowRight: ReactNode;
}

/**
 * Grid layout component for the club dashboard main content
 * Uses full width of the available space
 */
export const ClubGrid = ({
  topRowLeft,
  topRowRight,
  teamPanel,
  bottomRowLeft,
  bottomRowRight
}: ClubGridProps) => {
  return (
    <div className="flex flex-col gap-6 w-full">
      {/* Top Row - NextFixturePanel */}
      <div className="w-full">
        {topRowRight}
      </div>

      {/* Team Panel Row - Takes 3/4 of vertical space */}
      <div className="w-full">
        {teamPanel}
      </div>

      {/* Bottom Row - Split into two columns */}
      <div className="w-full grid grid-cols-2 gap-6">
        <div>
          {bottomRowLeft}
        </div>
        <div>
          {bottomRowRight}
        </div>
      </div>
    </div>
  );
};